import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../components/ui/card";
import ListItem from "./list-item";
import CustomerCard from "./customer-card";
import { useMemo } from "react";
import LottieEmptyState from "../no-data-animation/index";
import Utility from "../../../../helper/utilityHelper";

const TopCustomers = ({ topCustomers }) => {
  // Parse the JSON string data
  const parsedData = useMemo(() => {
    if (!topCustomers) return null;
    
    try {
      let result;
      // If topCustomers is a string, parse it
      if (typeof topCustomers === 'string') {
        result = JSON.parse(topCustomers);
      } else {
        // If topCustomers is already an object, return as is
        result = topCustomers;
      }
      
      return result;
    } catch (error) {
      console.error('Error parsing topCustomers data:', error);
      return null;
    }
  }, [topCustomers]);

  // Transform data to match component expectations
  const transformedData = useMemo(() => {
    if (!parsedData || !Array.isArray(parsedData)) return [];

    // Sort customers by totalSpent in descending order (highest first)
    const sortedCustomers = [...parsedData].sort((a, b) => {
      const amountA = parseFloat(a.totalSpent) || 0;
      const amountB = parseFloat(b.totalSpent) || 0;
      return amountB - amountA; // Descending order
    });

    return sortedCustomers.map((customer, index) => ({
      id: customer.playerId || index,
      name: customer.playerName || "Unknown Customer",
      phone: customer.playerPhone || "",
      amount: customer.totalSpent ? Utility.formatNumber(customer.totalSpent) : "0",
      totalCourtBookings: customer.totalCourtBookings || 0,
      color: index < 3 ? ["success", "primary", "info"][index] : "warning",
      rank: index + 1
    }));
  }, [parsedData]);

  if (!parsedData || !Array.isArray(parsedData) || parsedData.length === 0) {
    return (
      <Card>
        <CardHeader className="flex-row justify-between items-center gap-4 mb-0 border-none p-6">
          <CardTitle>Top Customers</CardTitle>
        </CardHeader>
        <CardContent>
          <LottieEmptyState
            title="No Customer Data"
            subtitle="Customer information will appear here when available"
            height={400}
            width={200}
          />
        </CardContent>
      </Card>
    );
  }

  const topThreeData = transformedData.slice(0, 3);
  const remainingData = transformedData.slice(3);

  return (
    <Card>
      <CardHeader className="flex-row justify-between items-center gap-4 mb-0 border-none p-6">
        <CardTitle>Top Customers</CardTitle>
      </CardHeader>
      <CardContent className="pt-0 ">
        <div className="pt-16">
          <div className={`grid gap-16 md:gap-6 ${
            topThreeData.length === 1 
              ? 'justify-center pb-4' 
              : topThreeData.length === 2 
                ? 'md:grid-cols-2 justify-center pb-4' 
                : 'md:grid-cols-3 pb-4 px-4'
          }`}>
            {topThreeData.map((item, index) => (
              <CustomerCard key={item.id} item={item} index={index + 1} />
            ))}
          </div>
          {remainingData.length > 0 && (
            <div className="mt-4 pb-6 px-4">
              {remainingData.map((item, index) => (
                <ListItem
                  key={`customer-${item.id}`}
                  item={item}
                  index={index + 4}
                />
              ))}
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default TopCustomers;
